<template>
  <div class="menu-recordings-manager">
    <v-slide-y-transition>
      <v-alert v-if="showAlert" :color="alertColor" border="left" dense dismissible class="alert-message"
        @input="showAlert = false">
        {{ alertText }}
      </v-alert>
    </v-slide-y-transition>

    <div class="recordings-grid-container">
      <v-row>
        <v-col cols="12" sm="6" md="6" lg="4" v-for="(item, index) in items" :key="index">
          <v-card class="recording-card">
            <v-card-title class="recording-title">
              {{ item.name }}
              <v-select v-if="item.fileName === 'start_message.wav'" :items="types" item-text="text" item-value="value"
                v-model="item.isPressable" dense hide-details class="message-type-select" style="max-width: 120px;"
                background-color="rgba(0, 0, 0, 0.03)"></v-select>
            </v-card-title>

            <v-card-text class="recording-content">
              <div class="upload-button-container">
                <!-- <v-btn color="primary" class="upload-button" elevation="1" height="40">
                  <v-icon left>mdi-paperclip</v-icon>
                  <label :for="'fileInput' + index" class="upload-label">
                    Choose File
                  </label>
                  <v-file-input :id="'fileInput' + index" v-model="item.fileInput" @change="handleFileInputChange(item)"
                    class="hidden-input"></v-file-input>
                </v-btn> -->
                <v-btn color="primary" class="upload-button" elevation="1" height="40"
                  @click="$refs['fileInput' + index][0].$refs.input.click()">
                  <v-icon left>mdi-paperclip</v-icon>
                 Choose File
                  <v-file-input :ref="'fileInput' + index" v-model="item.fileInput"
                    @change="handleFileInputChange(item)" class="hidden-input"></v-file-input>
                </v-btn>

                <div v-if="item.name === 'Temporary Message' && item.fileInput" class="date-picker-container">
                  <DatePicker v-model="datePicker" />
                </div>
              </div>

              <v-progress-linear v-if="item.progressUpload" indeterminate color="primary" height="4"
                class="progress-indicator"></v-progress-linear>

              <div v-if="item.progressLoading" class="loading-indicator">
                <v-progress-circular indeterminate color="primary" size="24"></v-progress-circular>
              </div>

              <v-slide-y-transition>
                <div v-if="(item.fileInput || item.existsOnServer) && !item.progressUpload" class="file-display">
                  <div class="file-name">
                    <template v-if="isFile(item.fileInput)">
                      {{ item.fileInput.name }}
                    </template>

                    <template v-else-if="item.fileInput">
                      {{ item.fileName }}
                    </template>

                    <template v-else-if="item.existsOnServer">
                      {{ item.fileName }}
                    </template>
                  </div>

                  <v-btn v-if="item.name !== 'Main Menu'" icon x-small @click="deleteFile(item)" class="delete-button">
                    <v-icon small color="error">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-slide-y-transition>

              <div class="audio-controls" :class="{ disabled: !item.fileInput && !item.existsOnServer }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon x-small v-on="on" @click="volume(item)"
                      :disabled="!item.fileInput && !item.existsOnServer" class="control-btn">
                      <v-icon small>
                        {{ item.muted ? 'mdi-volume-off' : 'mdi-volume-high' }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Volume</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon x-small v-on="on" @click="fast(item)"
                      :disabled="!item.fileInput && !item.existsOnServer" class="control-btn">
                      <v-icon small>mdi-fast-forward</v-icon>
                    </v-btn>
                  </template>
                  <span>Fast Forward</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon x-small v-on="on" @click="slow(item)"
                      :disabled="!item.fileInput && !item.existsOnServer" class="control-btn">
                      <v-icon small>mdi-rewind</v-icon>
                    </v-btn>
                  </template>
                  <span>Rewind</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon x-small v-on="on" @click="stop(item)"
                      :disabled="!item.fileInput && !item.existsOnServer" class="control-btn">
                      <v-icon small>mdi-stop</v-icon>
                    </v-btn>
                  </template>
                  <span>Stop</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon x-small v-on="on" @click="pause(item)"
                      :disabled="!item.fileInput && !item.existsOnServer" class="control-btn">
                      <v-icon small>mdi-pause</v-icon>
                    </v-btn>
                  </template>
                  <span>Pause</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon x-small v-on="on" @click="play(item)"
                      :disabled="!item.fileInput && !item.existsOnServer" class="control-btn play-btn">
                      <v-icon small>mdi-play</v-icon>
                    </v-btn>
                  </template>
                  <span>Play</span>
                </v-tooltip>

                <v-tooltip bottom v-if="item.fileInput">
                  <template v-slot:activator="{ on }">
                    <v-btn icon x-small v-on="on" @click="uploadFile(item)" class="control-btn upload-btn">
                      <v-icon small>mdi-cloud-upload</v-icon>
                    </v-btn>
                  </template>
                  <span>Upload this file to server</span>
                </v-tooltip>

                <v-tooltip bottom v-if="item.fileInput">
                  <template v-slot:activator="{ on }">
                    <a :href="item.fileInput" :download="item.fileName">
                      <v-btn icon x-small v-on="on" class="control-btn download-btn">
                        <v-icon small>mdi-download</v-icon>
                      </v-btn>
                    </a>
                  </template>
                  <span>Download file</span>
                </v-tooltip>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <div class="save-changes-container">
      <v-btn color="primary" @click="saveLimitDateAndPriority()" class="save-button">
        <v-icon left>mdi-content-save</v-icon>
        Save Changes
      </v-btn>
    </div>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
  </div>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'
import Auth from '@/services/auth.service.js'
import axios from 'axios'
import DatePicker from "@/components/widgets/DatePicker";

export default {
  components: {
    SnackBar,
    DatePicker,
  },
  data: () => ({
    userName: "",
    lineNumber: "",
    snackbar: false,
    datePicker: "",
    snackbarColorBt: "green",
    snacbarText: "",
    types: [{ text: "Skippable", value: "עקיף" }, { text: "Unskippable", value: "בלתי עקיף" }],
    showAlert: false,
    alertText: "",
    alertColor: "success",
    items: [
      {
        name: "Opening Message",
        fileInput: "",
        audioElement: "",
        fileName: "start_message.wav",
        isPressable: "עקיף",
        progressUpload: false,
        progressLoading: false,
        muted: false,
        existsOnServer: false, // חדש
      },
      {
        name: "Temporary Message",
        fileInput: "",
        audioElement: "",
        fileName: "temporary_message.wav",
        isPressable: "בלתי עקיף",
        progressUpload: false,
        progressLoading: false,
        muted: false,
        existsOnServer: false, // חדש
      },
    ]
  }),
  methods: {
    // פונקציה המקורית (כבר לא נקראת ב-mounted, אבל משאיר)
    async getRecords() {
      try {
        let token = localStorage.getItem("token");
        const links = [
          process.env.VUE_APP_BASE_URL + `/recordings/menu/${this.lineNumer}/start_message.wav`,
          process.env.VUE_APP_BASE_URL + `/recordings/menu/${this.lineNumer}/temporary_message.wav`
        ]
        for (let i = 0; i < 2; i++) {
          this.items[i].progressLoading = true;
          const res = await fetch(links[i], ApiServices.requestOptions("GET", "", token));
          const jsonObject = await res.blob();
          if (res.status === 200) {
            const url = URL.createObjectURL(jsonObject);
            this.items[i].fileInput = url;
            this.items[i].audioElement = new Audio(url);
            this.items[i].existsOnServer = true;
          }
          this.items[i].progressLoading = false;
        }
      } catch (error) {
        this.showSnackBar("Error get files: " + error, "red");
      }
    },

    async getLimitDateAndUnpress() {
      try {
        let token = localStorage.getItem("token");
        let api = process.env.VUE_APP_BASE_URL + `/records/get_limit_date_record_and_unpressed`;
        const res = await fetch(api, ApiServices.requestOptions("GET", "", token));
        const jsonObject = await res.json();
        if (res.status >= 400) {
          this.showAlert = true;
          this.alertText = "Error fetching data";
          this.alertColor = "error";
        } else if (res.status === 200) {
          if (jsonObject.menu_messages.temporary_message_limit) {
            const dateLimit = new Date(jsonObject.menu_messages.temporary_message_limit)
            // Extract date components
            const year = dateLimit.getFullYear();
            const month = String(dateLimit.getMonth() + 1).padStart(2, '0');
            const day = String(dateLimit.getDate()).padStart(2, '0');
            const hour = String(dateLimit.getHours()).padStart(2, '0');
            const minute = String(dateLimit.getMinutes()).padStart(2, '0');

            // Format as "YYYY-MM-DD hh:mm"
            this.datePicker = `${year}-${month}-${day} ${hour}:${minute}`;
          }
          for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].fileName === "start_message.wav") {
              let isPressable = jsonObject.menu_messages.start_message;
              if (isPressable === "pressable") {
                this.items[i].isPressable = "עקיף";
              } else {
                this.items[i].isPressable = "בלתי עקיף";
              }
              this.items[i].existsOnServer = !!jsonObject.menu_messages.start_message_exists;
            } else if (this.items[i].fileName === "temporary_message.wav") {
              let isPressable = jsonObject.menu_messages.temporary_message;
              if (isPressable === "pressable") {
                this.items[i].isPressable = "עקיף";
              } else {
                this.items[i].isPressable = "בלתי עקיף";
              }
              this.items[i].existsOnServer = !!jsonObject.menu_messages.temporary_message_exists;
            }
          }
        }
      } catch (error) {
        this.showSnackBar("Error get details: " + error, "red");
      }
    },

    async uploadFile(item) {
      try {
        if (item.fileInput instanceof File) {
          let type;
          if (item.name === "Opening Message") {
            type = "start_message"
          } else if (item.name === "Temporary Message") {
            type = "temporary_message"
          } else {
            return;
          }

          item.progressUpload = true;
          let token = localStorage.getItem("token");
          let api = process.env.VUE_APP_BASE_URL + `/records/change_menu_record`;

          const formData = new FormData();
          formData.append("record", item.fileInput);
          formData.append("type", type);
          const response = await axios.post(api, formData, {
            headers: {
              'Authorization': 'Bearer ' + token,
              'Content-Type': 'multipart/form-data'
            }
          });

          if (response.status >= 400) {
            item.progressUpload = false;
            this.showAlert = true;
            this.alertText = "Error: Cannot upload file " + item.fileInput.name;
            this.alertColor = "error";
          } else if (response.status === 200) {
            item.progressUpload = false;
            item.existsOnServer = true; // הקובץ עכשיו קיים בשרת
            this.showAlert = true;
            this.alertText = "File: " + item.fileInput.name + " Uploaded successfully to main folder as file " + item.name;
            this.alertColor = "success";
          }
        }
      } catch (error) {
        item.progressUpload = false;
        this.showSnackBar("Error get files: " + error, "red");
      }
    },

    handleFileInputChange(item) {
      if (item.fileInput) {
        // קובץ מקומי חדש – מחליף כל מה שהיה קודם
        item.audioElement = new Audio(URL.createObjectURL(item.fileInput));
      } else {
        item.audioElement = "";
      }
    },

    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true;
    },

    async loadRecording(item) {
      // אם כבר יש אודיו (משרת או מקובץ מקומי) – לא להוריד שוב
      if (item.audioElement || item.fileInput instanceof File) {
        return;
      }

      // אם השרת אומר שאין קובץ – אין מה להוריד
      if (!item.existsOnServer) {
        return;
      }

      try {
        item.progressLoading = true;
        let token = localStorage.getItem("token");

        const link = process.env.VUE_APP_BASE_URL +
          `/recordings/menu/${this.lineNumer}/${item.fileName}`;

        const res = await fetch(link, ApiServices.requestOptions("GET", "", token));

        if (res.status === 200) {
          const blob = await res.blob();
          const url = URL.createObjectURL(blob);
          item.fileInput = url;
          item.audioElement = new Audio(url);
        } else {
          // לדוגמה 404 – בפועל אין קובץ
          item.existsOnServer = false;
        }
      } catch (error) {
        this.showSnackBar("Error get files: " + error, "red");
      } finally {
        item.progressLoading = false;
      }
    },

    async ensureAudio(item) {
      if (!item.audioElement) {
        await this.loadRecording(item);
      }
      return !!item.audioElement;
    },

    async volume(item) {
      const ok = await this.ensureAudio(item);
      if (!ok) return;

      if (item.audioElement.volume > 0) {
        item.audioElement.volume = 0.0;
        item.muted = true;
      } else {
        item.audioElement.volume = 0.6;
        item.muted = false;
      }
    },

    async fast(item) {
      const ok = await this.ensureAudio(item);
      if (!ok) return;

      if (item.audioElement.playbackRate < 1.8) {
        item.audioElement.playbackRate += 0.4;
        item.audioElement.play();
      }
    },

    async slow(item) {
      const ok = await this.ensureAudio(item);
      if (!ok) return;

      if (item.audioElement.playbackRate > 0.2) {
        item.audioElement.playbackRate -= 0.4;
        item.audioElement.play();
      }
    },

    async play(item) {
      const ok = await this.ensureAudio(item);
      if (!ok) return;

      item.audioElement.play();
      item.audioElement.addEventListener('ended', () => {
        this.stop(item);
      });
      item.audioElement.addEventListener('error', (event) => {
        this.stop(item);
        this.showSnackBar('Error: Invalid audio file', "red");
      });
    },

    stop(item) {
      if (item.audioElement) {
        item.audioElement.pause();
        item.audioElement.currentTime = 0;
      }
    },

    pause(item) {
      if (item.audioElement) {
        item.audioElement.pause();
      }
    },

    async deleteFile(item) {
      // Clear the file input
      item.fileInput = '';
      item.audioElement = '';
      item.existsOnServer = false;

      try {
        let token = localStorage.getItem("token");
        const itemsJSON = JSON.stringify({ fileName: item.fileName });
        let api = process.env.VUE_APP_BASE_URL + `/records/delete_menu_record`;
        const res = await fetch(api, ApiServices.requestOptions("DELETE", itemsJSON, token));

        if (res.status >= 400) {
          this.showAlert = true;
          this.alertText = "Error deleting message";
          this.alertColor = "error";
        } else if (res.status === 200) {
          this.showAlert = true;
          this.alertText = "Message deleted successfully";
          this.alertColor = "success";
        }
      } catch (error) {
        this.showSnackBar("Error delete record: " + error, "red");
      }
    },

    isFile(input) {
      return input instanceof File;
    },

    async saveLimitDateAndPriority() {
      try {
        let token = localStorage.getItem("token");
        const itemsJSON = JSON.stringify({
          dateTime: this.datePicker,
          start_message: this.items[0].isPressable,
          temporary_message: this.items[1].isPressable
        });
        let api = process.env.VUE_APP_BASE_URL + `/records/save_limit_date_record_and_unpressed`;
        const res = await fetch(api, ApiServices.requestOptions("POST", itemsJSON, token));

        if (res.status >= 400) {
          this.showAlert = true;
          this.alertText = "Error saving changes";
          this.alertColor = "error";
        } else if (res.status === 200) {
          this.showAlert = true;
          this.alertText = "Changes saved successfully!";
          this.alertColor = "success";
        }
      } catch (error) {
        this.showSnackBar("Error save changes: " + error, "red");
      }
    }
  },
  watch: {
    datePicker() {
      // This was in the original code but the variable 'scheduleChange' is not defined
      // this.scheduleChange = true
    }
  },
  mounted() {
    this.lineNumer = Auth.getLineNumber();
    this.getLimitDateAndUnpress();
    // לא מורידים אוטומטית את ההקלטות
    // this.getRecords();
  },
}
</script>




<style scoped>
/* Keeping styles exactly as they were */
.menu-recordings-manager {
  padding: 0 16px;
}

.alert-message {
  margin-bottom: 16px;
  border-radius: 8px;
}

.recordings-grid-container {
  margin-bottom: 32px;
}

.recording-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
  transition: all 0.3s ease;
}

.recording-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.recording-title {
  position: relative;
  font-size: 18px;
  font-weight: 600;
  color: #0d2c6d;
  padding: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  background-color: rgba(0, 0, 0, 0.02);
  display: flex;
  justify-content: space-between;
}


.recording-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 16px;
}

.upload-button-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
}

.upload-button {
  background: linear-gradient(135deg, #0d2c6d 0%, #1a4ba5 100%) !important;
  color: white !important;
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.upload-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(13, 44, 109, 0.3) !important;
}

.upload-label {
  cursor: pointer;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hidden-input {
  display: none;
}

.date-picker-container {
  margin-top: 16px;
  width: 100%;
}

.progress-indicator {
  margin: 16px 0;
}

.loading-indicator {
  display: flex;
  justify-content: center;
  margin: 16px 0;
}

.file-display {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(0, 0, 0, 0.03);
  padding: 8px 12px;
  border-radius: 8px;
  margin: 16px 0;
}

.file-name {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.7);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  direction: ltr;
  text-align: left;
  flex-grow: 1;
  padding-left: 8px;
}

.delete-button {
  background-color: rgba(244, 67, 54, 0.1);
  transition: all 0.2s ease;
}

.delete-button:hover {
  background-color: rgba(244, 67, 54, 0.2);
}

.audio-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: auto;
  padding-top: 16px;
}

.audio-controls.disabled .control-btn {
  opacity: 0.5;
  cursor: not-allowed;
}

.control-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
}

.control-btn:hover:not([disabled]) {
  background-color: rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.play-btn {
  background-color: rgba(13, 44, 109, 0.1);
}

.play-btn:hover:not([disabled]) {
  background-color: rgba(13, 44, 109, 0.2);
}

.download-btn {
  background-color: rgba(76, 175, 80, 0.1);
}

.download-btn:hover {
  background-color: rgba(76, 175, 80, 0.2);
}

.upload-btn {
  background-color: rgba(33, 150, 243, 0.1);
}

.upload-btn:hover {
  background-color: rgba(33, 150, 243, 0.2);
}

.save-changes-container {
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
}

.save-button {
  background: linear-gradient(135deg, #0d2c6d 0%, #1a4ba5 100%) !important;
  color: white !important;
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0;
  padding: 0 24px;
  height: 44px;
  transition: all 0.3s ease;
}

.save-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(13, 44, 109, 0.3) !important;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .menu-recordings-manager {
    padding: 0 8px;
  }

  .recording-title {
    font-size: 16px;
    padding: 12px;
  }

  .message-type-select {
    position: static;
    width: 100%;
    margin-top: 8px;
  }

  .audio-controls {
    flex-wrap: wrap;
  }
}
</style>